






























import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import CurrencyData from '@/data/CurrencyData';
import CurrencyModule from '@/store/modules/Currency';

@Component({
  components: {
    Table,
  },
})
export default class CurrencyRateView extends Vue {
  TableHead = CurrencyData.TableHead;

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  currency: any = []

  created() {
    this.fetchCurrency();
  }

  async fetchCurrency() {
    const res = await this.CurrencyInstance.fetchCurrencyRate();
    this.currency = res.rateCurrency;
  }
}
